import { useEffect, useState } from "react";

import { Staff } from "../types";
import { getStaffByType } from "../service/staffService";

export function useStaffList(staffType: string) {
  const [staff, setStaff] = useState<Staff[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!staffType) {
      setStaff([]);
      return;
    }

    const fetchStaff = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getStaffByType(staffType);
        setStaff(data);
      } catch (e: any) {
        setError(e.message || "Failed to fetch staff");
      } finally {
        setLoading(false);
      }
    };

    fetchStaff();
  }, [staffType]);

  return {
    staff,
    loading,
    error,
  };
}
